import { render } from "./popover.vue?vue&type=template&id=06caf516&scoped=true"
import script from "./popover.vue?vue&type=script&lang=js"
export * from "./popover.vue?vue&type=script&lang=js"

import "./popover.vue?vue&type=style&index=0&id=06caf516&lang=css"
import "./popover.vue?vue&type=style&index=1&id=06caf516&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06caf516"]])

export default __exports__